/**
 * Converts a raw MyDATA invType code (e.g. "1.1") to the i18n key used in MYDATA_INV_TYPES.
 * Dots are replaced with underscores because i18next treats "." as a key-path separator.
 * Usage: t(invTypeI18nKey("1.1")) → "Sales Invoice"
 */
export const invTypeI18nKey = (code: string | number): string =>
  `MYDATA_INV_TYPES.${String(code).replace('.', '_')}`;
